<template>
  <div>
    <div height="100%" class="ShowCreateMelkUser">
      <!-- <div class="TopShowBackToPage">
        <h1>خرید اشتراک</h1>

        <div @click="ShowBtnCreate" class="ShowIconVsIcon">
          <i class="fas fa-arrow-left" style="font-size: 24px"></i>
        </div>
      </div> -->
      <div class="createMelkHeader">
        <div class="createMelkHeaderContainer">
          <div class="createMelkHeaderTitle">
            <h1>خرید اشتراک</h1>
          </div>

          <div @click="ShowBtnCreate" class="ShowIconVsIcon">
            <i class="fas fa-arrow-left" style="font-size: 24px"></i>
          </div>
        </div>
      </div>

      <div class="subscribtionPlans">
        <div class="subscribtionPlansContainer">
          <div class="subscribtionPlansBoxesWrapper desktopPlan">
            <div
              v-for="(v, i) in data_list"
              :key="i"
              class="subscribtionPlansBox"
              :class="v.pishnahad == 1 ? 'popular' : ''"
            >
              <div class="boxMain">
                <div class="mainHeader">
                  <div class="boxTitle">{{ v.title }}</div>
                  <div class="boxPrice">
                    <div class="priceTitle">
                      <div class="titleNum">{{ formatPrice(v.price) }}</div>
                      <div class="title">{{ $store.state.c_set.currency }}</div>
                    </div>
                    <div class="priceLabel">/ {{ v.type }}</div>
                  </div>
                </div>
                <div class="mainContent">
                  <div class="boxDesc">
                    {{ v.des }}
                  </div>
                  <div class="boxFeatures">
                    <div
                      v-for="(vv, ii) in v.property"
                      :key="ii"
                      class="featureThumb"
                    >
                      <div class="thumbIcon"><i class="fas fa-check"></i></div>
                      <div class="thumbTitle">{{ vv.property }}</div>
                    </div>

                    <div
                      v-for="(vvv, iii) in v.property2"
                      :key="iii"
                      class="featureThumb disable"
                    >
                      <div class="thumbIcon">
                        <i class="fa-solid fa-xmark"></i>
                      </div>
                      <div class="thumbTitle">{{ vvv.property2 }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="boxFooter">
                <div class="boxBtn" @click="tariff_buy(v.id)">خرید اشتراک</div>
              </div>
            </div>
          </div>
          <div class="subritionsListContainer mobilePlan">
            <div class="containerHeader">
              <div class="headerContainer" v-if="tariffLoading">
                <Swiper :slides-per-view="3" :space-between="20">
                  <SwiperSlide v-for="i in 3" :key="i">
                    <Skeletor
                      class="containerBoxSk"
                      style="background: rgb(163, 219, 213)"
                    />
                  </SwiperSlide>
                </Swiper>
              </div>
              <div class="headerContainer" v-if="!tariffLoading">
                <Swiper :slides-per-view="3" :space-between="20">
                  <SwiperSlide v-for="(v, i) in data_list" :key="i">
                    <div
                      class="containerBox"
                      :class="{ active: activeIndex == i }"
                      @click="activeIndex = i"
                    >
                      <div class="boxIcon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-crown-icon lucide-crown"
                        >
                          <path
                            d="M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z"
                          />
                          <path d="M5 21h14" />
                        </svg>
                      </div>
                      <div class="boxContent">
                        <div class="contentTitle">
                          {{ v.title }}
                        </div>
                        <div class="contentSubtitle">
                          {{ v.type }}
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
            <div class="containerMain">
              <div class="mainContainer" v-if="tariffLoading">
                <Skeletor
                  class="mainContainerSk"
                  style="background: rgb(163, 219, 213)"
                />
              </div>
              <div class="mainContainer" v-if="!tariffLoading">
                <div class="containerHeader">
                  <div class="headerTitle">
                    اشتراک {{ data_list?.[activeIndex]?.title }}
                  </div>
                  <div class="headerType">
                    <div class="typeTitle">مدت اشتراک:</div>
                    <div class="typeValue">
                      {{ data_list?.[activeIndex]?.type }}
                    </div>
                  </div>
                </div>
                <div class="containerList">
                  <div
                    class="listThumb"
                    v-for="(p, j) in data_list?.[activeIndex]?.property"
                    :key="j"
                  >
                    <div class="listThumbItem">
                      <div class="thumbIcon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-check-icon lucide-check"
                        >
                          <path d="M20 6 9 17l-5-5" />
                        </svg>
                      </div>
                      <div class="thumbTitle">
                        {{ p.property }}
                      </div>
                    </div>

                    <div class="thumbTitle">{{ p.meta_value }} عدد</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="containerFooter">
              <div class="footerContainer">
                <div class="wallet-row">
                  <div class="wallet-left-side">
                    <div>
                      <div class="wallet-lbl">استفاده از کیف پول</div>
                      <div class="wallet-bal">
                        موجودی: {{ fmt(walletBal) }} تومان
                      </div>
                    </div>
                  </div>
                  <label class="toggle">
                    <input type="checkbox" v-model="with_credit" />
                    <span class="slider"></span>
                  </label>
                </div>
                <div class="containerContent">
                  <div class="contentTitle">مبلغ قابل پرداخت:</div>
                  <div v-if="!tariffLoading" class="contentPrice">
                    <span class="priceNum">
                      {{ formatPrice(finalTotal) }}
                    </span>
                    <span
                      class="priceUnit"
                      v-if="
                        data_list &&
                        data_list[activeIndex] &&
                        data_list[activeIndex].price != 0
                      "
                    >
                      {{ $store.state.c_set.currency }}
                    </span>
                  </div>
                </div>
                <div class="containerOption">
                  <div
                    class="optionBuy"
                    @click="tariff_buy(data_list?.[activeIndex]?.id)"
                  >
                    خرید اشتراک
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Skeletor } from "vue-skeletor";
import { toast } from "vue3-toastify";
import "swiper/css";

export default {
  name: "buySubscribtion",
  components: {
    Swiper,
    SwiperSlide,
    Skeletor,
  },
  data() {
    return {
      showSubscribtion: false,
      color: "#2dc653",
      activeBox: "2",
      data_list: [],
      activeIndex: 0,
      tariffLoading: false,
      walletBal: this.$store.state.auth.credit,
      with_credit: false,
    };
  },
  computed: {
    finalTotal() {
      return this.with_credit
        ? Math.max(
            0,
            this.data_list?.[this.activeIndex]?.price - this.walletBal
          )
        : this.data_list?.[this.activeIndex]?.price;
    },
  },
  methods: {
    fmt(n) {
      return Number(n).toLocaleString("fa-IR");
    },
    async tariff_buy(id) {
      if (this.finalTotal > 0) {
        this.$swal
          .fire({
            title: "اتصال به درگاه",
            text:
              "خرید اعتبار به مبلغ" +
              " " +
              this.formatPrice(this.finalTotal) +
              " تومان",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#0096c7",
            cancelButtonColor: "#fff",
            confirmButtonText: "تایید",
            cancelButtonText: "انصراف",
          })
          .then((result) => {
            if (result.isConfirmed) {
              if (result.value) {
                this.helperPost("tariff-buy", {
                  tariff_id: id,
                  with_credit: this.with_credit ? 1 : 0,
                }).then((r) => {
                  if (r.data.result == 0) {
                    toast(r.data.msg, {
                      type: "error",
                      dangerouslyHTMLString: true,
                    });
                  } else {
                    if (r.data.data.pay == 1) {
                      let link = r.data.data.url;
                      window.open(link, "_blank");
                    } else {
                      this.$emit("subscribtionBought");
                    }
                  }
                });
              }
            }
          });
      } else {
        this.helperPost("tariff-buy", {
          tariff_id: id,
          with_credit: this.with_credit ? 1 : 0,
        }).then((r) => {
          if (r.data.result == 0) {
            toast(r.data.msg, {
              type: "error",
              dangerouslyHTMLString: true,
            });
          } else {
            if (r.data.data.pay == 1) {
              let link = r.data.data.url;
              window.open(link, "_blank");
            } else {
              toast("اشتراک باموفقیت خریداری شد", {
                type: "success",
                dangerouslyHTMLString: true,
              });
              this.$emit("subscribtionBought");
            }
          }
        });
      }
    },

    load_data() {
      this.tariffLoading = true;
      this.helperPost("tariff-list")
        .then((r) => {
          if (r.data.result == 1) {
            this.data_list = r.data.data;
          }
          this.tariffLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.tariffLoading = false;
        });
    },
    OpenSubsMOdal() {
      this.showSubscribtion = true;
      document.body.style.overflow = "hidden";
    },

    ShowBtnCreate() {
      history.back();
      this.showSubscribtion = false;
      document.body.style.overflow = "auto";
    },
    changeActiveBox(index) {
      this.activeBox = index;
    },
    loadTheme() {
      const width = window.innerWidth;
      if (width >= 1250) {
        this.color = "#2dc653";
      } else {
        this.color = "#f5f5f5";
      }
    },
  },
  mounted() {
    this.activeTag = "همه";
    this.OpenSubsMOdal();
    this.load_data();
  },
};
</script>

<style lang="scss" scoped>
@import url("../../../public/css/tailwindcss.css");
html {
  color: #656c7c;
  font-size: 16px;
  line-height: 1.5;
}

.plans {
  width: 96%;
  max-width: 1128px;
  margin: 0 auto;
}
/*.plans__container {
  padding: 1rem 0 2rem;
}*/

.plansHero {
  text-align: center;
  padding: 5rem 0 4.5rem;
  line-height: 1.21;
}
.plansHero__title {
  font-weight: 700;
  font-size: 2rem;
  margin: 0 0 1rem 0;
  color: #000;
}
.plansHero__subtitle {
  margin: 0;
}

.planItem {
  background-color: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 1rem;
  box-shadow: none;
  padding: 2rem 1.5rem;
  display: inline-flex;
  flex-direction: column;
  transform: scale(0.93);
  transition: all 0.1s;
  cursor: pointer;

  &.active {
    transform: scale(1);
    background: #f4fffa;
    border: 1px solid #d7d7d7;

    .button {
      background: #0096c7;
      color: #fff;
    }

    .label {
      background-color: #0096c7;
      color: #fff;
    }
  }
}
.planItem__container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
}
.planItem .price {
  margin: 2rem 0;
}
.planItem--pro {
  border: 0;
  box-shadow: 0px 14px 30px rgba(204, 204, 204, 0.32);
}
.planItem--pro .label {
  background-color: #ade8f4;
  color: #000;
}
.planItem--entp .card {
  --titleColor: #fff;
  --descColor: rgb(255 255 255 / 80%);
}

.planItem--entp .featureList {
  color: #fff;
}
.planItem--entp .featureList {
  --icon: url("data:image/svg+xml,%3Csvg width='18' height='14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16.552.134 5.717 10.97 1.448 6.701 0 8.149l5.717 5.717L18 1.583 16.552.134Z' fill='%23FFFFFF'/%3E%3C/svg%3E%0A");
}
.planItem .button {
  margin-top: auto;
}

.button {
  background-color: #90e0ef;
  color: #000;
  border-radius: 0.5rem;
  display: block;
  width: 100%;
  padding: 1rem 1.5rem;
  border: 0;
  line-height: inherit;
  font-family: inherit;
  font-size: 1rem;
  font-family: "iranyekanB", sans-serif;
  font-weight: 500;
  text-align: center;
  cursor: pointer;
  transition: all 0.1s;
  transition: all 0.1s ease-in-out;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.button:hover {
  transform: translateY(-2px);
  box-shadow: 0px 6px 10px rgba(234, 76, 137, 0.3);
}
.button:focus-visible {
  outline-offset: 2px;
  outline: 2px solid #ea4c89;
}

.card {
  --titleColor: #000;
  --descColor: #656c7c;
}
.card__header {
  display: flex;
  gap: 1rem;
  align-items: center;
}
.card__icon {
  width: 2.625rem;
  height: 2.625rem;
}
.card h2 {
  color: #000;
  font-size: 1.5rem;
  line-height: 1.2;
  font-weight: 400;
  margin: 0;
  flex-grow: 1;
}
.card__desc {
  margin: 1.5rem 0 0;
  color: #656c7c;
}

.label {
  background-color: #e5e5e5;
  color: #656c7c;
  font-weight: 600;
  line-height: 1.25;
  font-size: 1rem;
  text-align: center;
  padding: 0.625rem 1.125rem;
  border-radius: 2rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.price {
  color: #000;
  display: flex;
  align-items: center;
  gap: 0.5625rem;
  font-weight: 600;
  font-size: 2rem;
  margin: 0;
}
.price span {
  font-size: 1rem;
  font-weight: 400;
  color: #656c7c;
}

.featureList {
  color: #000;
  margin: 0 0 2.75rem;
  padding: 0;
  font-weight: 500;
}
.featureList li {
  color: #000;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}
.featureList li:before {
  content: "";
  background-image: url("data:image/svg+xml,%3Csvg width='18' height='14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16.552.134 5.717 10.97 1.448 6.701 0 8.149l5.717 5.717L18 1.583 16.552.134Z' fill='%232dc653'/%3E%3C/svg%3E%0A");
  background-size: cover;
  display: block;
  width: 1.125rem;
  height: 0.875rem;
}
.featureList li:last-child {
  margin-bottom: 0;
}
.featureList li.disabled {
  color: #b1b8c9;
  --height: 1.125rem;
  --icon: url("data:image/svg+xml,%3Csvg width='18' height='18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18 1.414 16.586 0 9 7.586 1.414 0 0 1.414 7.586 9 0 16.586 1.414 18 9 10.414 16.586 18 18 16.586 10.414 9 18 1.414Z' fill='%23B1B8C9'/%3E%3C/svg%3E");
}
.featureList li.disabled:before {
  content: "";
  background-image: url("data:image/svg+xml,%3Csvg width='18' height='18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18 1.414 16.586 0 9 7.586 1.414 0 0 1.414 7.586 9 0 16.586 1.414 18 9 10.414 16.586 18 18 16.586 10.414 9 18 1.414Z' fill='%23B1B8C9'/%3E%3C/svg%3E");
  background-size: cover;
  display: block;
  width: 1.125rem;
  height: 1.125rem;
}

.symbol {
  border: 2px solid #1769ff;
  width: 2.625rem;
  height: 2.625rem;
  border-radius: 0.25rem;
  position: relative;
}
.symbol--rounded {
  border-radius: 2rem;
}
.symbol:after {
  content: "";
  box-sizing: border-box;
  display: block;
  position: absolute;
  border: 2px solid #ea4c89;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.25rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.dark {
  .wallet-row {
    background: #414648;
    border-color: #4d4d4f;
  }

  .wallet-lbl {
    color: #fff;
  }
}

.wallet-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8fbff;
  border-radius: 12px;
  padding: 11px 14px;
  border: 1px solid #e0f0ff;
  margin-block: -4px 12px;
}

.wallet-left-side {
  display: flex;
  align-items: center;
  gap: 10px;
}

.wallet-icon-wrap {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #fff0f6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.wallet-lbl {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a2e;
  margin-bottom: 6px;
}
.wallet-bal {
  font-size: 12px;
  color: #0284c7;
  font-weight: 600;
}

.toggle {
  position: relative;
  width: 44px;
  height: 24px;
}
.toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  inset: 0;
  background: #d1d9e6;
  border-radius: 24px;
  cursor: pointer;
  transition: background 0.25s;
}
.slider::before {
  content: "";
  position: absolute;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  top: 3px;
  right: 3px;
  transition: transform 0.25s;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
}
.toggle input:checked + .slider {
  background: #0096c7;
}
.toggle input:checked + .slider::before {
  transform: translateX(-20px);
}

@media screen and (max-width: 1250px) {
  .plans {
    width: 90%;
  }
  .planItem__container {
    grid-template-columns: 1fr 1fr;
  }
}

@media screen and (max-width: 800px) {
  /*.planSectionContainer {
    width: 96% !important;
    padding: 0 !important;
  }*/

  .plans {
    width: 100%;
    transform: scale(0.96);
  }

  /*.planSection {
    padding-top: 44px !important;
  }*/

  /*.plans__container {
    padding: 0 !important;
  }*/

  .planItem__container {
    grid-template-columns: 1fr;
    gap: 0;
  }
}

@media screen and (min-width: 641px) and (max-width: 768px) {
  html {
    font-size: 12px;
  }
}
@media screen and (min-width: 769px) and (max-width: 1080px) {
  html {
    font-size: 14px;
  }
}
</style>
